export default __webpack_public_path__ + "static/media/announcement-highlight-details-inner.87673638.svg";